import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSimpleListIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4426_11372)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M36 0H4C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H36C38.2091 32 40 30.2091 40 28V4C40 1.79086 38.2091 0 36 0Z",
				fill: "#76ec71"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_4426_11372",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 9,
				y: 5,
				width: 22,
				height: 22,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M31 5H9V27H31V5Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_4426_11372)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M20.8486 17.7352L16.483 9.49374C16.425 9.38201 16.3373 9.28835 16.2298 9.22298C16.1222 9.15761 15.9987 9.12305 15.8728 9.12305C15.7469 9.12305 15.6234 9.15761 15.5158 9.22298C15.4082 9.28835 15.3206 9.38201 15.2626 9.49374L10.897 17.7352L9.07514 21.1812C8.99296 21.3435 8.97752 21.5314 9.03213 21.7048C9.08673 21.8782 9.20704 22.0234 9.36732 22.1093C9.52954 22.1916 9.71746 22.207 9.89092 22.1523C10.0644 22.0978 10.2096 21.9774 10.2954 21.8172L11.9196 18.7492H19.8259L21.4501 21.8172C21.5075 21.9293 21.595 22.0233 21.7028 22.0885C21.8106 22.1538 21.9343 22.1878 22.0603 22.1867C22.1785 22.1868 22.2948 22.1565 22.3979 22.0984C22.5009 22.0405 22.5873 21.957 22.6487 21.8559C22.71 21.7548 22.7442 21.6396 22.748 21.5214C22.7519 21.4032 22.7251 21.2861 22.6705 21.1812L20.8486 17.7352ZM12.6501 17.3742L15.8728 11.2812L19.0955 17.3742H12.6501ZM26.8728 13.1547C25.9246 13.1454 25.0108 13.5097 24.329 14.1687C24.2595 14.2307 24.2034 14.3061 24.1639 14.3904C24.1244 14.4747 24.1025 14.5662 24.0994 14.6592C24.0964 14.7523 24.1122 14.8449 24.146 14.9317C24.1799 15.0184 24.2309 15.0973 24.2961 15.1638C24.3614 15.2301 24.4394 15.2826 24.5255 15.3179C24.6116 15.3532 24.704 15.3707 24.7971 15.3694C24.8902 15.3679 24.982 15.3475 25.067 15.3096C25.152 15.2716 25.2283 15.2168 25.2915 15.1484C25.7167 14.7422 26.2848 14.5198 26.8728 14.5297C28.0071 14.5297 28.9353 15.3031 28.9353 16.2484V16.8672C28.3245 16.4607 27.6065 16.2453 26.8728 16.2484C24.9736 16.2484 23.4353 17.6321 23.4353 19.3422C23.4353 21.0523 24.9736 22.4359 26.8728 22.4359C27.6316 22.4391 28.3729 22.208 28.9955 21.7742C29.0478 21.897 29.1354 22.0017 29.2469 22.0751C29.3585 22.1485 29.4893 22.1873 29.6228 22.1867C29.8052 22.1867 29.98 22.1143 30.109 21.9853C30.2378 21.8564 30.3103 21.6815 30.3103 21.4992V16.2484C30.3103 14.5383 28.772 13.1547 26.8728 13.1547ZM26.8728 21.0609C25.7384 21.0609 24.8103 20.2875 24.8103 19.3422C24.8103 18.3968 25.7384 17.6234 26.8728 17.6234C28.0071 17.6234 28.9353 18.3968 28.9353 19.3422C28.9353 20.2875 28.0071 21.0609 26.8728 21.0609Z",
					fill: "#0f172b"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.30469 7.99969C4.30469 7.61585 4.61585 7.30469 4.99969 7.30469H7.49969C7.88353 7.30469 8.19469 7.61585 8.19469 7.99969C8.19469 8.38353 7.88353 8.69469 7.49969 8.69469H5.69469V22.3047H7.49969C7.88353 22.3047 8.19469 22.6158 8.19469 22.9997C8.19469 23.3835 7.88353 23.6947 7.49969 23.6947H4.99969C4.61585 23.6947 4.30469 23.3835 4.30469 22.9997V7.99969Z",
				fill: "#0f172b"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M35.8906 7.99969C35.8906 7.61585 35.5795 7.30469 35.1956 7.30469H32.6956C32.3118 7.30469 32.0006 7.61585 32.0006 7.99969C32.0006 8.38353 32.3118 8.69469 32.6956 8.69469H34.5006V22.3047H32.6956C32.3118 22.3047 32.0006 22.6158 32.0006 22.9997C32.0006 23.3835 32.3118 23.6947 32.6956 23.6947H35.1956C35.5795 23.6947 35.8906 23.3835 35.8906 22.9997V7.99969Z",
				fill: "#0f172b"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4426_11372",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgSimpleListIcon;
